"use client";

import Link from "next/link";

import { useMarketingFooterLinks } from "@/hooks/use-marketing-nav";
import { cn } from "@/lib/utils";

export function MarketingFooter({ className }: { className?: string }) {
  const footerLinks = useMarketingFooterLinks();

  return (
    <footer
      className={cn(
        "mt-auto w-full shrink-0 border-t border-border py-8 text-[12px] text-muted-foreground",
        className,
      )}
    >
      <div className="mx-auto flex w-full max-w-6xl flex-col items-center gap-4 px-6 md:flex-row md:items-center md:justify-between">
        <p className="text-center md:text-left">
          © {new Date().getFullYear()} Inora. All rights reserved.
        </p>

        <nav
          aria-label="Footer"
          className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2"
        >
          {footerLinks.map((item) =>
            item.isCurrent ? (
              <span
                key={item.label}
                className="text-muted-foreground"
                aria-current="page"
              >
                {item.label}
              </span>
            ) : (
              <Link
                key={item.label}
                href={item.href}
                className="text-muted-foreground no-underline transition-colors hover:text-foreground"
              >
                {item.label}
              </Link>
            ),
          )}
        </nav>
      </div>
    </footer>
  );
}
